import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  seatCharacters: {},
  isLoading: false,
  error: "",
  hasData: false
};
const seatCharacteristicsSlice = createSlice({
  name: "seatCharacteristics",
  initialState,
  reducers: {
    seatCharacteristicsRequest: state => {
      state.isLoading = true;
    },
    seatCharacteristicsSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.seatCharacters = action.payload;
    },
    seatCharacteristicsFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    }
  }
});
export const {
  seatCharacteristicsRequest,
  seatCharacteristicsSuccess,
  seatCharacteristicsFailure
} = seatCharacteristicsSlice.actions;
export default seatCharacteristicsSlice.reducer;